import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-excluparts',
  templateUrl: './home-excluparts.component.html',
  styleUrls: ['./home-excluparts.component.scss']
})
export class HomeExclupartsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
